module.exports = __webpack_public_path__ + "static/img/bds.d57a71e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bds.jpg
// module id = Ahmw
// module chunks = 1